import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialStoragePageState,
  StorageItemData,
} from "../core/_model.storage";
import {
  ActionedTypeDefault,
  DefaultListResponse,
  DefaultListStateType,
} from "../../../common/models/StoreDefaultModel";

export type ActionedStorage = {
  data: StorageItemData | null;
  action: ActionsKey;
};

type StorageType = {
  list: Array<any>;
  totalItems: number;
  pageState: any;
  actioned: ActionedStorage | null;
  setList: (cont: any) => void;
  setPageState: (cont: any) => void;
  setActioned: (act: ActionedTypeDefault | null) => void;

  resetPageState: () => void;
};

type StorageDataType = {
  storageList: any;
  detail: StorageItemData | null;
  actioned: ActionedStorage | null;
  totalItems?: number;
  setDetail: (detail: StorageItemData | null) => void;
  setStorageList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedStorage | null) => void;
};

export const useStorageStore = create<StorageDataType>(
  (set) => ({
    storageList: [],
    detail: null,
    actioned: null,

    setDetail: (detail) => set((state) => ({ detail })),
    setStorageList: (saleData) =>
      set((state) => ({
        storageList: saleData?.member,
        totalItems: saleData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useStorageListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialStoragePageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);


/**
 * Container
 */
export const useStorageContainerStore =
  create<StorageType>((set) => ({
    list: [],
    totalItems: 0,
    actioned: null,
    pageState: initialStoragePageState,
    setList: (data) =>
      set(() => ({
        list: data?.member,
        totalItems: data?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),

    setPageState: (data) => set(() => ({ pageState: data })),
    resetPageState: () => set(() => ({ pageState: initialStoragePageState })),
  }));

  /**
   * Bag
   */
  export const useStorageBagStore =
  create<StorageType>((set) => ({
    list: [],
    totalItems: 0,
    actioned: null,
    pageState: initialStoragePageState,
    setList: (data) =>
      set(() => ({
        list: data?.member,
        totalItems: data?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),

    setPageState: (data) => set(() => ({ pageState: data })),
    resetPageState: () => set(() => ({ pageState: initialStoragePageState })),
  }));

  /**
   * Vehicle
   */
  export const useStorageVehicleStore =
  create<StorageType>((set) => ({
    list: [],
    totalItems: 0,
    actioned: null,
    pageState: initialStoragePageState,
    setList: (data) =>
      set(() => ({
        list: data?.member,
        totalItems: data?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),

    setPageState: (data) => set(() => ({ pageState: data })),
    resetPageState: () => set(() => ({ pageState: initialStoragePageState })),
  }));

  /**
   * Craft
   */
  export const useStorageCraftStore =
  create<StorageType>((set) => ({
    list: [],
    totalItems: 0,
    actioned: null,
    pageState: initialStoragePageState,
    setList: (data) =>
      set(() => ({
        list: data?.member,
        totalItems: data?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),

    setPageState: (data) => set(() => ({ pageState: data })),
    resetPageState: () => set(() => ({ pageState: initialStoragePageState })),
  }));

  /**
   * Other
   */
  export const useStorageOtherStore =
  create<StorageType>((set) => ({
    list: [],
    totalItems: 0,
    actioned: null,
    pageState: initialStoragePageState,
    setList: (data) =>
      set(() => ({
        list: data?.member,
        totalItems: data?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),

    setPageState: (data) => set(() => ({ pageState: data })),
    resetPageState: () => set(() => ({ pageState: initialStoragePageState })),
  }));